import { render } from "./Student.vue?vue&type=template&id=7af1b449"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"
script.render = render

export default script